import { render, staticRenderFns } from "./QuotationCalculationTab.vue?vue&type=template&id=25696756"
import script from "./QuotationCalculationTab.vue?vue&type=script&lang=js"
export * from "./QuotationCalculationTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports